import { navigate } from 'gatsby';
import React from 'react';
import { pushProductClickToDataLayer } from '../../../../utils/dataLayer/productClick';
import {
  returnCurrencyCharFromCode,
  returnLocalisedPath,
} from '../../../../utils/globals';
import { withLocale } from '../../../../utils/hocs';
import { ShopProductItemCard } from '../../../UI/Cards/Shop/ProductItem/shopProductItemCard';
import { returnProductSlugUrl } from '../ProductItem/shopProductItem.utils';

export const ShopProductPackItem = withLocale(
  ({ product, label, badges, buttons, subLabel, locale }) => {
    const price = product.fields?.shopifyData?.variants[0].priceV2?.amount;
    const compareAtPrice =
      product.fields?.shopifyData?.variants[0].compareAtPriceV2?.amount;
    const currency = returnCurrencyCharFromCode(
      product.fields?.shopifyData?.variants[0].priceV2?.currencyCode
    );
    const handleButtonClick = () => {
      // Datalayer => product click
      pushProductClickToDataLayer(product);

      // Navigate to the product page
      navigate(
        returnLocalisedPath(locale[0], returnProductSlugUrl(product.slug))
      );
    };
    return (
      <ShopProductItemCard
        onClick={handleButtonClick}
        label={label}
        product={product}
        showColorPicker={false}
        subLabel={subLabel}
        badges={badges}
        price={price}
        currency={currency}
        compareAtPrice={compareAtPrice}
        button={buttons[0]}
      />
    );
  }
);
